import { useEffect, useState } from "react";

export default function Reviews() {
  const API_URL = "/api/reviews/";
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setReviews(Array.isArray(data) ? data : data.results || []);
    } catch (err) {
      alert("Failed to load reviews");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this review permanently?")) return;

    setDeleting(id);

    try {
      const res = await fetch(`/api/reviews/delete/${id}/`, {
        method: "DELETE",
        headers: {
          Authorization: "7a8b9c0d1e2f3g4h5i6j7k8l9m0n1o2p3q4r5s6t",
          "Content-Type": "application/json",
        },
      });

      if (res.ok) {
        setReviews((prev) => prev.filter((r) => r.id !== id));
        alert("DELETED FOREVER");
      } else {
        alert("Delete failed");
      }
    } catch {
      alert("Network error");
    } finally {
      setDeleting(null);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-100">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Customer Reviews</h2>
        <button
          onClick={fetchReviews}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition"
        >
          Refresh
        </button>
      </div>

      {loading ? (
        <p className="text-gray-500">Loading reviews...</p>
      ) : reviews.length === 0 ? (
        <p className="text-center py-8 text-gray-500">No reviews yet.</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="border border-gray-200 rounded-xl p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">

                  {/* USER NAME ADDED HERE */}
                  <p className="font-bold text-gray-900 text-lg">
                    {review.user || "Anonymous"}
                  </p>

                  <div className="flex items-center gap-3 mb-2 mt-1">
                    <span className="font-semibold text-gray-800">
                      Product #{review.product}
                    </span>

                    <div className="flex gap-1">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={`text-lg ${
                            i < review.rating ? "text-yellow-500" : "text-gray-300"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>

                    <span className="text-sm text-gray-500">
                      {new Date(review.created_at).toLocaleDateString()}
                    </span>
                  </div>

                  <p className="text-gray-700 mt-2">{review.text}</p>
                </div>

                <button
                  onClick={() => handleDelete(review.id)}
                  disabled={deleting === review.id}
                  className={`ml-4 px-4 py-2 rounded-lg text-white text-sm font-medium transition ${
                    deleting === review.id
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-red-600 hover:bg-red-700"
                  }`}
                >
                  {deleting === review.id ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
